import { render, staticRenderFns } from "./sliderCode.vue?vue&type=template&id=53f615cf&scoped=true"
import script from "./sliderCode.vue?vue&type=script&lang=js"
export * from "./sliderCode.vue?vue&type=script&lang=js"
import style0 from "./sliderCode.vue?vue&type=style&index=0&id=53f615cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f615cf",
  null
  
)

export default component.exports